/* eslint indent: 0 */

import './media_library.folder_list_item.less';
import './media_library.folder_grid_item.less';

import AbstractItem from './media_library.abstract_item.js';

import folderListItemTemplate from  './media_library.folder_list_item.tpl';
import folderGridItemTemplate from  './media_library.folder_grid_item.tpl';

const FolderItem = AbstractItem.extend({
    
    className: 'media-library-folder media-library-item',
    
    template: null,
    
    initialize: function(options){
      if (options.assetDisplayState === 'list') {
        this.template = folderListItemTemplate;
      } else {
        this.template = folderGridItemTemplate;
      }
      this._initializeBaseListeners();
      if(options.allowDragging){
        this._bindItemDrop();
        // special folders can't be modified
        if(!this.model.get('special_folder_type')){
          this._bindDragging();
        }
      }
    },
    
    _bindItemDrop: function(){
      var me = this;
      me.$el.droppable({
        over: function(){
          $(this).addClass('item-dragged-over');
        },
        out: function(){
          $(this).removeClass('item-dragged-over');
        },
        drop: function( event, ui ) {
          me.trigger('dropped-on', ui.draggable);
          $(this).removeClass('item-dragged-over');
        }
      });
    },
    
    render: function() {
      var me = this;
      me.$el.html(me.template({
        model: this.model
      }));
      this.$el.addClass('folder-type-' + (this.model.get('special_folder_type')||'normal'));
      return me;
    }
    
  });
  

export default FolderItem;